{
  "book_now": {
    "en": "Book Now",
    "de": "Jetzt Buchen",
    "nl": "Boek Nu",
    "pt": "Reservar",
    "es": "Reservar",
    "it": "Prenotare",
    "fr": "Réserver Maintenant"
  },
  "evo_preview_title": {
    "en": "EVO preview unavailable",
    "de": "EVO-Vorschau nicht verfügbar",
    "nl": "EVO-preview niet beschikbaar",
    "pt": "Pré-visualização do EVO indisponível",
    "es": "Vista previa de EVO no disponible",
    "it": "Anteprima EVO non disponibile",
    "fr": "Aperçu EVO indisponible"
  },
  "evo_preview_error": {
    "en": "The EVO preview could not be loaded.",
    "de": "Die EVO-Vorschau konnte nicht geladen werden.",
    "nl": "De EVO-preview kon niet worden geladen.",
    "pt": "Não foi possível carregar a pré-visualização do EVO.",
    "es": "No se pudo cargar la vista previa de EVO.",
    "it": "Non è stato possibile caricare l'anteprima EVO.",
    "fr": "L’aperçu EVO n’a pas pu être chargé."
  },
  "exit_preview": {
    "en": "Exit Preview",
    "de": "Vorschau verlassen",
    "nl": "Voorbeeldweergave verlaten",
    "pt": "Sair da pré-visualização",
    "es": "Salir de la vista previa",
    "it": "Esci dall'anteprima",
    "fr": "Quitter l’aperçu"
  }
}
